(() => {
  'use strict';

  if (window.BHProductDetails) return;

  const loadPurchaseProof = async (dialog) => {
    if (!dialog || dialog.dataset.proofLoaded === 'true') return;
    dialog.dataset.proofLoaded = 'true';
    const url = dialog.dataset.proofUrl;
    const row = dialog.querySelector('[data-bh-product-purchase-proof]');
    const label = dialog.querySelector('[data-bh-product-purchase-proof-text]');
    if (!url || !row || !label) return;

    try {
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const proof = await response.json();
      const orders = Number(proof?.verifiedOrders || 0);
      if (!Number.isFinite(orders) || orders < 3) return;
      label.textContent = `${orders} compras verificadas recientemente`;
      row.hidden = false;
    } catch (_) {
      // La prueba social es complementaria; el panel sigue funcionando sin red.
    }
  };

  const open = (trigger) => {
    const id = trigger.getAttribute('aria-controls');
    const dialog = id ? document.getElementById(id) : null;
    if (!(dialog instanceof HTMLDialogElement)) return;
    if (!dialog.open) dialog.showModal();
    loadPurchaseProof(dialog);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-bh-product-details-open]');
    if (trigger) {
      event.preventDefault();
      open(trigger);
      return;
    }

    const close = event.target.closest('[data-bh-product-details-close]');
    if (close) close.closest('dialog')?.close();
  });

  document.addEventListener('click', (event) => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement) || !dialog.matches('[data-bh-product-details-dialog]')) return;
    const rect = dialog.getBoundingClientRect();
    const outside =
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom;
    if (outside) dialog.close();
  });

  window.BHProductDetails = Object.freeze({ open });
})();
